import { render, staticRenderFns } from "./pricing-compare-table.vue?vue&type=template&id=1d6722bd&scoped=true&"
import script from "./pricing-compare-table.vue?vue&type=script&lang=js&"
export * from "./pricing-compare-table.vue?vue&type=script&lang=js&"
import style0 from "./pricing-compare-table.vue?vue&type=style&index=0&id=1d6722bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6722bd",
  null
  
)

export default component.exports